"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_iMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "9AD6C7D6-D431-471C-A124-A50BAEEB0C18"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.7936478%",
    y1: "93.361933%",
    x2: "50.7936478%",
    y2: "12.4104664%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBD2A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BF675",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-79.000000, -335.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-/-iMessage-/-App-Launcher",
    transform: "translate(79.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IMessage_logo",
    transform: "translate(0.000000, 0.888889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect826",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 7.82749182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5955128,6 C9.1915037,6 4,10.3241778 4,15.6582782 C4.00570049,19.0472987 6.14354914,22.1858822 9.63325612,23.9284824 C9.17631499,24.9514556 8.49100043,25.9107305 7.60568931,26.7665863 C9.32251879,26.4652051 10.9341423,25.8320756 12.3151245,24.9164752 C13.3799353,25.1800241 14.4846873,25.314763 15.5955128,25.3165612 C21.9995244,25.316519 27.1910261,20.9923806 27.1910261,15.6582782 C27.1910261,10.3241777 21.9995221,6 15.5955128,6 L15.5955128,6 Z",
    id: "path922",
    fill: "#FFFFFF"
  }))))));
}

var _default = ic_iMessage;
exports.default = _default;